import { getNavLink } from '../../utils/nav';
import { IToolData } from '../tools';
import {
  TEXT_TOOLS,
  IMAGE_TOOLS,
  VIDEO_TOOLS,
  DESIGN_TOOLS,
  COLOR_TOOLS,
  AI_WRITER_TOOLS,
} from '../tools';
import { ICON_COLOR, ICON_BACKGROUND, ICON_FILL } from '../colors';

export interface INavLink {
  navLink: string;
  label: string;
  itemsCount: number;
  viewAllItems: boolean;
  subLinks: IToolData[];
  iconColor?: string;
  fillColor?: string;
  isNew?: boolean;
  hasBullet?: boolean;
}

export const NAVBAR_LINKS: INavLink[] = [
  {
    label: 'Text',
    itemsCount: 7,
    viewAllItems: false,
    subLinks: TEXT_TOOLS,
    navLink: getNavLink('/text'),
    iconColor: ICON_BACKGROUND[ICON_COLOR.blue],
    fillColor: ICON_FILL[ICON_COLOR.blue],
  },
  {
    label: 'AI Writer',
    itemsCount: 7,
    viewAllItems: true,
    subLinks: AI_WRITER_TOOLS,
    navLink: getNavLink('/text/ai-writer'),
    iconColor: ICON_BACKGROUND[ICON_COLOR.lightGreen],
    fillColor: ICON_FILL[ICON_COLOR.lightGreen],
  },
  {
    label: 'Image',
    itemsCount: 7,
    viewAllItems: false,
    subLinks: IMAGE_TOOLS,
    navLink: getNavLink('/image'),
    iconColor: ICON_BACKGROUND[ICON_COLOR.magenta],
    fillColor: ICON_FILL[ICON_COLOR.magenta],
  },
  {
    label: 'Video',
    itemsCount: 7,
    viewAllItems: false,
    subLinks: VIDEO_TOOLS,
    navLink: getNavLink('/video'),
    iconColor: ICON_BACKGROUND[ICON_COLOR.yellow],
    fillColor: ICON_FILL[ICON_COLOR.yellow],
  },
  {
    label: 'Design',
    itemsCount: 7,
    viewAllItems: false,
    subLinks: DESIGN_TOOLS,
    navLink: getNavLink('/design'),
    iconColor: ICON_BACKGROUND[ICON_COLOR.purple],
    fillColor: ICON_FILL[ICON_COLOR.purple],
    hasBullet: true,
  },
  {
    label: 'Color',
    itemsCount: 7,
    viewAllItems: false,
    subLinks: COLOR_TOOLS,
    navLink: getNavLink('/color'),
    iconColor: ICON_BACKGROUND[ICON_COLOR.indigo],
    fillColor: ICON_FILL[ICON_COLOR.indigo],
  },
  //Temp removed according to ST-1571
  // {
  //   label: 'Convert',
  //   itemsCount: 7,
  //   viewAllItems: false,
  //   subLinks: CONVERT_TOOLS,
  //   navLink: getNavLink('/convert'),
  //   iconColor: ICON_BACKGROUND[ICON_COLOR.green],
  //   fillColor: ICON_FILL[ICON_COLOR.green],
  // },
  // {
  //   label: 'PDF',
  //   itemsCount: 7,
  //   viewAllItems: false,
  //   subLinks: PDF_TOOLS,
  //   navLink: getNavLink('/pdf'),
  //   iconColor: ICON_BACKGROUND[ICON_COLOR.red],
  //   fillColor: ICON_FILL[ICON_COLOR.red],
  // },
];
